import axios from "axios";

export const LOGIN_URL = "/api/v2/users/auth";
export const ME_URL = "/api/v2/users/me";
export const CONFIRM_ACCOUNT_URL = "/api/v1/users/confirm";

export function login(email, password) {
  return axios.post(LOGIN_URL, { email, password, force_admin: true });
}

export function getUserByToken() {
  return axios.get(ME_URL);
}

export function confirmAccount(token, password) {
  const payload = { token };
  if (password !== undefined) {
    payload.password = password;
  }
  return axios.post(CONFIRM_ACCOUNT_URL, payload);
}
